<template>
  <div>
    <CommonDivider v-if="!isMm()" class="md:my-15" />
    <NewsletterSignup :large="true" always-show />
    <CommonDivider class="md:my-15" />
  </div>
</template>
<script setup lang="ts"></script>
